// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .jobs-list .v-expansion-panel-content__wrap{padding:0}@media only screen and (min-width:960px){.hrsata-jobs .jobs-list .v-expansion-panel-content__wrap{padding:16px 24px}}", ""]);
// Exports
module.exports = exports;
